import { useState } from "react";
import {
  Modal,
  Box,
  IconButton,
  Typography,
  Divider,
  TextField,
  MenuItem,
  Button,
  CircularProgress,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import BlockIcon from "@mui/icons-material/Block";
import { globalStyle } from "../../global/Utils";
import { blockReasons, OTHER_BLOCK_REASON } from "./Variables";

const BlockUserModal = ({
  loader,
  open,
  setOpen,
  userName,
  handleSubmit,
}) => {
  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  const isOther = reason === OTHER_BLOCK_REASON;
  const resolvedReason = isOther ? customReason.trim() : reason;
  const canConfirm = resolvedReason !== "" && !loader;

  const handleClose = () => {
    setOpen(false);
    setReason("");
    setCustomReason("");
  };

  const handleConfirm = () => {
    if (!canConfirm) return;
    handleSubmit(resolvedReason, handleClose);
  };

  if (!open) return null;
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="block-user-modal-title"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 420 },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: "24px",
          borderRadius: 2,
        }}
      >
        <IconButton onClick={handleClose} sx={{ float: "right", color: "black" }}>
          <CancelIcon sx={{ fontSize: "28px" }} />
        </IconButton>
        <Box sx={{ display: "flex", alignItems: "center", m: 2, ml: { xs: 1, md: 3 } }}>
          <BlockIcon fontSize="medium" sx={{ mr: 1, color: "#FA4C2A" }} />
          <Typography
            id="block-user-modal-title"
            variant="subtitle1"
            fontFamily={globalStyle.fontFamilyParagraph}
            fontSize={globalStyle.fontSize}
          >
            Block User
          </Typography>
        </Box>
        <Divider />

        <Box sx={{ mt: 2 }}>
          <Typography
            sx={{
              fontSize: 14,
              fontFamily: globalStyle.fontFamilyParagraph,
              color: "#666",
              mb: 2,
            }}
          >
            {userName
              ? `Select a reason for blocking ${userName}.`
              : "Select a reason for blocking this user."}
          </Typography>

          <TextField
            select
            required
            fullWidth
            size="small"
            id="block-reason"
            label="Reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            sx={{ borderRadius: globalStyle.borderRadius }}
          >
            {blockReasons.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </TextField>

          {isOther && (
            <TextField
              margin="dense"
              required
              fullWidth
              size="small"
              id="custom-block-reason"
              label="Custom Reason"
              placeholder="Enter the reason for blocking this user"
              autoFocus
              multiline
              minRows={2}
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value.toUpperCase())}
              sx={{ mt: 2, borderRadius: globalStyle.borderRadius }}
            />
          )}

          <Box
            display="flex"
            flexDirection={{ xs: "column", md: "row" }}
            gap={2}
            sx={{ mt: 3 }}
          >
            <Button
              type="button"
              fullWidth
              variant="outlined"
              disabled={loader}
              onClick={handleClose}
              sx={{
                color: globalStyle.bgColorBlue,
                borderColor: globalStyle.bgColorBlue,
                fontFamily: globalStyle.fontFamilyButton,
                fontSize: globalStyle.fontSize,
              }}
            >
              Cancel
            </Button>
            <Button
              type="button"
              fullWidth
              variant="contained"
              disabled={!canConfirm}
              onClick={handleConfirm}
              sx={{
                bgcolor: globalStyle.buttonColor,
                fontFamily: globalStyle.fontFamilyButton,
                fontSize: globalStyle.fontSize,
              }}
            >
              {loader ? <CircularProgress color="inherit" size={24} /> : "Block User"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default BlockUserModal;
